import { toast, ToastOptions } from "react-toastify";
export const ToastyWhite = (
  content: string,
  options?: ToastOptions | undefined
) => toast(content, options);
